cockpitApp.directive('specialHintBar', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/detail/special-hint-bar',
    controllerAs: 'specialHintBarCtrl',
    controller: 'specialHintBarController'
  };
});
